<script setup lang="ts">
import { WidgetRatesActionValue } from '~/components/widget/rates'
import { SUPPORTED_CURRENCIES } from '~/data/pages/rates/consts'
import type { IBankByRelatedRates } from '~/components/widget/rates'

const route = useRoute()

const currencyParam = computed(() => {
  const param = route.params.currency
  return Array.isArray(param) ? param[0]?.toUpperCase() : param?.toUpperCase()
})

const valueParam = computed(() => {
  const param = route.params.value
  return Array.isArray(param) ? param[0] : param
})

if (!SUPPORTED_CURRENCIES.includes(currencyParam.value)) {
  showError({ statusCode: 404 })
}

const apiParams = computed(() => ({
  action: 'sell' as const,
  currency: currencyParam.value.toLowerCase(),
  rate: valueParam.value
}))

const { data: banksData } = await useFetch<IBankByRelatedRates[]>('/api/rates/values-cached', {
  params: apiParams,
  key: `rates-related-banks-${currencyParam.value}-sell-${valueParam.value}`,
  server: true
})

const hasMatchingRate = computed(() => {
  if (!banksData.value) return false

  const targetRate = parseFloat(valueParam.value)
  const rateKey = `sell_${currencyParam.value.toLowerCase()}` as keyof IBankByRelatedRates['rates']

  return banksData.value.some((bank) => parseFloat(String(bank.rates[rateKey])) === targetRate)
})

watchEffect(() => {
  if (banksData.value && !hasMatchingRate.value) {
    showError({
      statusCode: 404
    })
  }
})
</script>

<template>
  <WidgetRatesActionValue :banks="banksData" :has-matching-rate="hasMatchingRate" />
</template>
